module.exports = __webpack_public_path__ + "img/back neck drop.872257f1.png";